<template>
    <div class="card-container">
        <common-top-form
            selectShowPower="/vipapppointsnewodetoJoyinfo/select"
            :model="formModel"
            :submitService="submitService"
            :submitData="submitData"
            @success="onSuccess"
            :show="false"
            downloadPower="/vipapppointsnewodetoJoyinfo/PeopleExport"
            :showDownloadPower="false"
            @down="down"
            showDownloadPowerType="warning"
        >
            <el-form-item label="商户号">
                <el-input v-model="formModel.merNo" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="商户名称">
                <el-input v-model="formModel.merName" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="代理商ID">
                <el-input v-model="formModel.agentId" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="状态">
                <el-select v-model="formModel.status">
                    <el-option
                        v-for="item in status"
                        :key="item.dictKey"
                        :label="item.dictValue"
                        :value="item.dictKey"
                    >
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="银行卡类型">
                <el-select v-model="formModel.custAccountCreditOrDebit">
                    <el-option
                        v-for="item in card"
                        :key="item.dictKey"
                        :label="item.dictValue"
                        :value="item.dictKey"
                    >
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="支付状态">
                <el-select v-model="formModel.payStatus">
                    <el-option
                        v-for="item in payStatus"
                        :key="item.dictKey"
                        :label="item.dictValue"
                        :value="item.dictKey"
                    >
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="支付时间">
                <el-date-picker
                    v-model="formModel.payTime"
                    type="daterange"
                    range-separator="至"
                    :clearable="true"
                    value-format="yyyy-MM-dd"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                >
                </el-date-picker>
            </el-form-item>
            <el-form-item label="创建时间">
                <el-date-picker
                    v-model="formModel.time"
                    type="daterange"
                    range-separator="至"
                    :clearable="true"
                    value-format="yyyy-MM-dd"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                >
                </el-date-picker>
            </el-form-item>
        </common-top-form>
        <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
            <el-table-column
                prop="orderNo"
                label="订单号"
                :formatter="formatterTableData"
                min-width="300"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="merNo"
                label="商户号"
                :formatter="formatterTableData"
                min-width="160"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="merName"
                label="商户名称"
                :formatter="formatterTableData"
                min-width="160"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="agentId"
                label="代理商ID"
                :formatter="formatterTableData"
                min-width="160"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="activityName"
                label="活动名称"
                :formatter="formatterTableData"
                min-width="160"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="number"
                label="期数"
                :formatter="formatterTableData"
                min-width="160"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="qualifiedTransactions"
                label="达标交易量(元)"
                :formatter="formatterTableNumberYuan"
                min-width="160"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="reward"
                label="每期奖励金(元)"
                :formatter="formatterTableNumberYuan"
                min-width="160"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="amount"
                label="交易金额(元)"
                :formatter="formatterTableNumberYuan"
                min-width="160"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="status"
                label="状态"
                :formatter="formatterTablestatus"
                min-width="160"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="custName"
                label="（ 银行卡预留姓名"
                :formatter="formatterTableData"
                min-width="160"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="custBindPhoneNo"
                label="银行卡预留手机号"
                :formatter="formatterTableData"
                min-width="160"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="custIdCard"
                label="银行卡预留身份证"
                :formatter="formatterTableData"
                min-width="260"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="custBankAccountNo"
                label="卡号"
                :formatter="formatterTableData"
                min-width="160"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="custBankNo"
                label="银行卡编码"
                :formatter="formatterTableData"
                min-width="160"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="custAccountCreditOrDebit"
                label="银行卡类型 ）"
                :formatter="formatterTableCardType"
                min-width="160"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="payStatus"
                label="支付状态"
                :formatter="formatterTablepayStatus"
                min-width="160"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="remark"
                label="备注"
                :formatter="formatterTableData"
                min-width="360"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="modifierName"
                label="操作人"
                min-width="160"
                show-overflow-tooltip
                :formatter="formatterTableData"
            ></el-table-column>
            <el-table-column
                prop="payTime"
                label="支付时间"
                min-width="160"
                show-overflow-tooltip
                :formatter="formatterTableData"
            ></el-table-column>
            <el-table-column
                prop="createTime"
                label="创建时间"
                min-width="160"
                show-overflow-tooltip
                :formatter="formatterTableData"
            ></el-table-column>
            <el-table-column
                v-if="hasPerm('/vipapppointsnewodetoJoyinfo/look')"
                label="操作"
                min-width="100"
                fixed="right"
            >
                <template slot-scope="scope">
                    <el-button
                        type="text"
                        v-if="hasPerm('/vipapppointsnewodetoJoyinfo/look')"
                        @click="look(scope.row)"
                    >明细
                    </el-button>
                    <el-button
                        type="text"
                        @click="transfer(scope.row)"
                    >转移
                    </el-button>
                </template>
            </el-table-column>
        </common-table>
        <form-dialog
            ref="formDialog"
            formDialogTitle="转移"
            :model="dialogModel"
            :submitData="dialogData"
            :rules="dialogRules"
            :dialogService="dialogService"
            @close="dialogClose"
            @success="dialogSuccess"
            class="note"
            labelWidth="120px"
            dialogWidth="460px"
        >
            <el-form-item label-width="135px" label="商户号" prop="merNo">
                <el-input v-model="dialogModel.merNo" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label-width="135px" label="备注" prop="remark">
                <el-input v-model="dialogModel.remark" placeholder="请输入"></el-input>
            </el-form-item>
        </form-dialog>
    </div>
</template>

<script>
    import CommonTopForm from "components/common/CommonTopForm";
    import CommonTable from "components/common/CommonTable";
    import TimeRange from "service/constant/TimeRange";
    import FormDialog from "../../dialog/FormDialog";

    import TransactionService from "service/TransactionService";
    import StatisticsService from "service/StatisticsService";
    import {encrypt, urlEncode, objKeySort} from "common/js/common-utils";
    import {loadMixin, dialogMixin, validatorsMixin} from "mixin";
    import {mapGetters} from "vuex";

    export default {
        name: "vipapppointsnewodetoJoyinfo",
        components: {
            CommonTopForm,
            CommonTable,
            FormDialog,
        },
        data() {
            return {
                formModel: {
                    merNo: "",
                    merName: "",
                    agentId: "",
                    status: "",
                    custAccountCreditOrDebit: "",
                    payStatus: "",

                    time: TimeRange.monthRange,
                    payTime: "",
                },
                tableData: [],
                card: [
                    {
                        dictKey: "",
                        dictValue: "全部",
                    },
                    {
                        dictKey: "1",
                        dictValue: "信用卡",
                    },
                    {
                        dictKey: "2",
                        dictValue: "储蓄卡",
                    },
                    {
                        dictKey: "3",
                        dictValue: "微信",
                    },
                ],
                payStatus: [
                    {
                        dictKey: "",
                        dictValue: "全部",
                    },
                    {
                        dictKey: "0",
                        dictValue: "待支付",
                    },
                    {
                        dictKey: "1",
                        dictValue: "已支付",
                    },
                    {
                        dictKey: "9",
                        dictValue: "失败",
                    },
                ],
                status: [
                    {
                        dictKey: "",
                        dictValue: "全部",
                    },
                    {
                        dictKey: "0",
                        dictValue: "未启动",
                    },
                    {
                        dictKey: "1",
                        dictValue: "进行中",
                    },
                    {
                        dictKey: "2",
                        dictValue: "已结束",
                    },
                ],
                dialogModel: {
                    merNo: '',
                    remark: ''
                },
                dialogRules: {
                    merNo: [
                        {
                            required: true,
                            message: "请输入",
                        },
                    ],
                    remark: [
                        {
                            required: true,
                            message: "请输入",
                        },
                    ],
                },
                itemId: '',
                submitService: TransactionService.zxinfoList,
                dialogService: TransactionService.MoveGlj,
                params: {},
                page: {},
                isPage: false,
            };
        },
        inject: ["reload"],
        mixins: [loadMixin, dialogMixin, validatorsMixin],
        mounted() {
            this.load();
        },
        computed: {
            submitData() {
                if (this.formModel.time == null || this.formModel.time == "") {
                    this.formModel.time = [];
                }
                if (this.formModel.payTime == null || this.formModel.payTime == "") {
                    this.formModel.payTime = [];
                }
                const params = {
                    merNo: this.formModel.merNo,
                    merName: this.formModel.merName,
                    agentId: this.formModel.agentId,
                    status: this.formModel.status,
                    custAccountCreditOrDebit: this.formModel.custAccountCreditOrDebit,
                    payStatus: this.formModel.payStatus,

                    current: this.isPage ? this.page.currentPage : 1,
                    size: this.page.pageSize,
                };
                if (this.formModel.time.length) {
                    params.startDate = this.formModel.time[0];
                    params.endDate = this.formModel.time[1];
                }
                if (this.formModel.payTime.length) {
                    params.startPayTime = this.formModel.payTime[0];
                    params.endPayTime = this.formModel.payTime[1];
                }
                return params;
            },
            dialogData() {
                return {
                    id: this.itemId,
                    merNo: this.dialogModel.merNo,
                    remark: this.dialogModel.remark,
                }
            },
            ...mapGetters(["serverType", "tatId", "userId", "userInfo"]),
        },
        methods: {
            load() {
                this.formModel = {
                    status: "",
                    custAccountCreditOrDebit: "",
                    payStatus: "",
                    time: TimeRange.monthRange,
                    payTime: "",
                };
                this.page = this.$refs.commonTable.page;
                this.getList();
            },
            getPage() {
                this.isPage = true;
                this.getList();
            },
            getList() {
                this.doLoad(
                    this.submitService,
                    this.submitData,
                    (res) => {
                        this.doCheck(res, (res) => {
                            this.onSuccess(res);
                            this.isPage = false;
                        });
                    },
                    "信息获取失败"
                );
            },
            onSuccess(res) {
                this.doCheck(res, (res) => {
                    const result = res.contents;
                    this.tableData = result.rows;
                    this.page.currentPage = result.current;
                    this.page.total = result.total;
                    this.page.pageSize = result.size;
                });
            },
            look(row) {
                this.$router.push({
                    name: "vipapppointsnewodetoJoyinfolook",
                    params: {
                        item: JSON.stringify(row),
                    },
                });
            },
            transfer(row) {
                this.itemId = row.id;
                this.$refs.formDialog.open();
            },
            formatterTablestatus(row, column, cellValue, index) {
                let value = "--";
                this.status.forEach((item) => {
                    if (item.dictKey == cellValue) {
                        value = item.dictValue;
                    }
                });
                return value;
            },
            formatterTableCardType(row, column, cellValue, index) {
                let value = "--";
                this.card.forEach((item) => {
                    if (item.dictKey == cellValue) {
                        value = item.dictValue;
                    }
                });
                return value;
            },
            formatterTablepayStatus(row, column, cellValue, index) {
                let value = "--";
                this.payStatus.forEach((item) => {
                    if (item.dictKey == cellValue) {
                        value = item.dictValue;
                    }
                });
                return value;
            },
            down() {
                this.limitExport(this.page.total)
                    ? StatisticsService.exportExcel(
                    this.submitData,
                    "exportHlfInfo",
                    "8885",
                    "/hlf/t-hlf-info-dtl/"
                    )
                    : "";
            },
            dialogClose() {
                this.dialogModel = {
                    merNo: '',
                    remark: ''
                };
                this.itemId = "";
            },
            dialogSuccess(res) {
                this.commonSuccess(res);
                this.$refs.formDialog.closeDialog();
            },
            commonSuccess(res) {
                this.showSuccess(res.respMsg);
                this.getList();
            },
        },
    };
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/view/page/AppManager/VipAppPointsNewOdeToJoyInfo.vue